

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})



// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});
});



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

jQuery(function ($) {
  var $parents = $('.l-header-nav__item--parent');

  $parents.click(function() {
    if ($(window).width() > 1280) return;

    // トグル
    $(this).toggleClass('is-open');
    $(this).children('.l-header-nav__sub').slideToggle();
  });
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('.l-header-nav').addClass('is_open');
				$('.l-header-nav').removeClass('is_close');
			} else {
				$('.l-header-nav').removeClass('is_open');
				$('.l-header-nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('.l-header-nav').removeClass('is_open');
			$('.l-header-nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('.l-header-nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-accordion-title').forEach(function(title) {
    title.addEventListener('click', function() {
      title.classList.toggle('is-open');
      var content = title.nextElementSibling;
      content.classList.toggle('is-open');
    });
  });
});

// サービスページ目次
jQuery(function ($) {
  var $sidebarLinks = $(".js-toc a");
  if ($sidebarLinks.length < 1) return;

  // セクション配列化
  var sections = $sidebarLinks.map(function () {
    var target = $($(this).attr("href"));
    return target.length ? target[0] : null;
  }).get();

  var ticking = false;

  $(window).on("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        var scrollTop = $(window).scrollTop();
        var headerHeight = $('header').innerHeight();

        var currentSection = null;

        for (var i = 0; i < sections.length; i++) {
          if ($(sections[i]).offset().top - headerHeight <= scrollTop) {
            currentSection = sections[i];
          }
        }

        if (currentSection) {
          var id = currentSection.id;
          $sidebarLinks.removeClass("is-current");
          $sidebarLinks
            .filter('[href="#' + id + '"]')
            .addClass("is-current");
        }

        ticking = false;
      });

      ticking = true;
    }
  });
});


// サービスページ目次
jQuery(function ($) {
  $(".js-toc-trigger").click(function () {
    $(this).toggleClass("is-active");
    $(this).next(".c-tocBox").toggleClass("is-active");
  });
});
